export const SET_BEHAVIOR = '[MODALS_BEHAVIOR] SET_BEHAVIOR';
